var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pa-0", attrs: { fluid: "" } },
    [
      _c("v-hover", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var hover = ref.hover
              return [
                _c(
                  "v-navigation-drawer",
                  {
                    attrs: { "mobile-breakpoint": "600", app: "", clipped: "" },
                    model: {
                      value: _vm.navDrawer,
                      callback: function ($$v) {
                        _vm.navDrawer = $$v
                      },
                      expression: "navDrawer",
                    },
                  },
                  [
                    _c(
                      "v-list",
                      { attrs: { expand: "", dense: "" } },
                      [
                        _c(
                          "v-card",
                          {
                            staticClass: "d-flex align-center",
                            attrs: { flat: "" },
                          },
                          [
                            _c(
                              "v-list-item",
                              {
                                attrs: { dense: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.goToFolder(_vm.computedFolderId)
                                  },
                                },
                              },
                              [
                                _c(
                                  "v-list-item-icon",
                                  { staticClass: "mr-0" },
                                  [
                                    _c("v-icon", { attrs: { small: "" } }, [
                                      _vm._v("mdi-arrow-left"),
                                    ]),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-list-item-content",
                                  [
                                    _c("v-list-item-title", [
                                      _vm._v(" Back to folder"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            hover || _vm.$vuetify.breakpoint.smAndDown
                              ? _c(
                                  "v-tooltip",
                                  {
                                    attrs: { bottom: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function (ref) {
                                            var on = ref.on
                                            return [
                                              _c(
                                                "v-btn",
                                                _vm._g(
                                                  {
                                                    attrs: { icon: "" },
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.navDrawer = false
                                                      },
                                                    },
                                                  },
                                                  on
                                                ),
                                                [
                                                  _c("v-icon", [
                                                    _vm._v(
                                                      "mdi-chevron-double-left"
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [_c("span", [_vm._v("Close side menu")])]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "v-list-item",
                          { staticClass: "mb-2" },
                          [
                            _c(
                              "v-list-item-content",
                              [
                                _c("SelectCase", {
                                  attrs: {
                                    folderId: _vm.computedFolderId,
                                    flat: "",
                                    "hide-details": "",
                                    "hide-create": "",
                                  },
                                  on: { "save-as": _vm.saveCaseAs },
                                  model: {
                                    value: _vm.case_id,
                                    callback: function ($$v) {
                                      _vm.case_id = $$v
                                    },
                                    expression: "case_id",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-list-item",
                          {
                            attrs: {
                              to: {
                                name: "CaseInput",
                                hash: "#Settings",
                                params: { folderId: _vm.computedFolderId },
                              },
                            },
                          },
                          [_c("v-list-item-title", [_vm._v("Settings")])],
                          1
                        ),
                        _vm.isRequired("Inputs")
                          ? _c(
                              "v-list-group",
                              {
                                attrs: { "no-action": "", value: true },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function () {
                                        return [
                                          _c(
                                            "v-list-item-content",
                                            [
                                              _c("v-list-item-title", [
                                                _vm._v("Inputs"),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _vm._l(_vm.inputPages, function (page) {
                                  return [
                                    !page.children
                                      ? _c(
                                          "v-list-item",
                                          {
                                            key: page.name,
                                            staticClass: "pl-8",
                                            attrs: {
                                              to: {
                                                name: "CaseInput",
                                                hash: _vm.hashify(page.name),
                                                params: {
                                                  folderId:
                                                    _vm.computedFolderId,
                                                },
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-list-item-content",
                                              [
                                                _c("v-list-item-title", [
                                                  _vm._v(_vm._s(page.name)),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _c(
                                          "v-list-group",
                                          {
                                            key: page.name,
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        "v-list-item-title",
                                                        { staticClass: "pl-4" },
                                                        [
                                                          _vm._v(
                                                            _vm._s(page.name)
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          _vm._l(
                                            page.children,
                                            function (child) {
                                              return _c(
                                                "v-list-item",
                                                {
                                                  key: child.name,
                                                  staticClass: "pl-12",
                                                  attrs: {
                                                    to: {
                                                      name: "CaseInput",
                                                      hash: _vm.hashify(
                                                        child.name
                                                      ),
                                                      params: {
                                                        folderId:
                                                          _vm.computedFolderId,
                                                      },
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-list-item-content",
                                                    [
                                                      _c("v-list-item-title", [
                                                        _vm._v(
                                                          _vm._s(child.name)
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          1
                                        ),
                                  ]
                                }),
                              ],
                              2
                            )
                          : _vm._e(),
                        _c(
                          "v-list-group",
                          {
                            attrs: { "no-action": "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function () {
                                    return [
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c("v-list-item-title", [
                                            _vm._v("Views"),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          _vm._l(_vm.viewsPages, function (page) {
                            return _c(
                              "v-list-item",
                              {
                                key: page.name,
                                staticClass: "pl-8",
                                attrs: {
                                  to: {
                                    name: "CaseVis",
                                    hash: _vm.hashify(page.name),
                                    params: { folderId: _vm.computedFolderId },
                                  },
                                },
                              },
                              [
                                _c(
                                  "v-list-item-content",
                                  [
                                    _c("v-list-item-title", [
                                      _vm._v(_vm._s(page.name)),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }),
                          1
                        ),
                        _c(
                          "v-list-item",
                          {
                            attrs: {
                              to: {
                                name: "CaseOutput",
                                params: { folderId: _vm.computedFolderId },
                              },
                              disabled:
                                !_vm.jobs.length ||
                                _vm.jobs.length == _vm.getJobsInProgress.length,
                            },
                          },
                          [_c("v-list-item-title", [_vm._v("Outputs")])],
                          1
                        ),
                        _c(
                          "v-list-group",
                          {
                            attrs: { "no-action": "", value: true },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function () {
                                    return [
                                      _c("v-list-item-title", [
                                        _vm._v("Calculations"),
                                      ]),
                                      _vm.jobLoadPending && !_vm.isJobInProgress
                                        ? _c(
                                            "v-list-item-action",
                                            { staticClass: "my-0" },
                                            [
                                              _c("v-progress-circular", {
                                                attrs: {
                                                  indeterminate: "",
                                                  color: "secondary",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm.isJobInProgress
                                        ? _c(
                                            "v-list-item-action",
                                            { staticClass: "my-0" },
                                            [
                                              _c(
                                                "v-tooltip",
                                                {
                                                  attrs: { top: "" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function (ref) {
                                                          var on = ref.on
                                                          return [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-caption",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Stop Jobs"
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "v-btn",
                                                              _vm._g(
                                                                {
                                                                  attrs: {
                                                                    icon: "",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        $event.stopPropagation()
                                                                        return _vm.cancelJobsInProgress()
                                                                      },
                                                                  },
                                                                },
                                                                on
                                                              ),
                                                              [
                                                                _c("v-icon", [
                                                                  _vm._v(
                                                                    "cancel"
                                                                  ),
                                                                ]),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "Stop Jobs In Progress"
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm.hasLogReports
                                        ? _c(
                                            "v-list-item-action",
                                            { staticClass: "my-0" },
                                            [
                                              _c(
                                                "MenuMore",
                                                {
                                                  attrs: {
                                                    "offset-x": "",
                                                    "offset-y": "",
                                                    origin: "top left",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-list",
                                                    { attrs: { dense: "" } },
                                                    _vm._l(
                                                      _vm.jobsWithLogReports,
                                                      function (job) {
                                                        return _c(
                                                          "v-list-item",
                                                          {
                                                            key:
                                                              "log-report-" +
                                                              job.type,
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.downloadLogReport(
                                                                  job.report_url
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item-icon",
                                                              [
                                                                _c("v-icon", [
                                                                  _vm._v(
                                                                    "get_app"
                                                                  ),
                                                                ]),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "v-list-item-content",
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.calculations.find(
                                                                        function (
                                                                          ref
                                                                        ) {
                                                                          var type =
                                                                            ref.type

                                                                          return (
                                                                            type ==
                                                                            job.type
                                                                          )
                                                                        }
                                                                      ).name
                                                                    ) +
                                                                    " Log Reports "
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _vm.currentCase
                              ? _vm._l(
                                  _vm.computedCalculations,
                                  function (page) {
                                    return _c(
                                      "v-list-item",
                                      {
                                        key: page.name,
                                        staticClass: "pl-8",
                                        attrs: {
                                          disabled:
                                            !_vm.jobStartable(page) ||
                                            _vm.jobLoadPending ||
                                            _vm.currentCase.locked,
                                        },
                                      },
                                      [
                                        _c(
                                          "v-list-item-content",
                                          [
                                            _c("v-list-item-title", [
                                              _vm._v(_vm._s(page.name)),
                                            ]),
                                            _vm.getJob(page.type)
                                              ? _c("v-list-item-subtitle", [
                                                  _vm._v(
                                                    _vm._s(
                                                      new Date(
                                                        _vm.getJob(
                                                          page.type
                                                        ).created
                                                      ).toLocaleString()
                                                    )
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-list-item-action",
                                          { staticClass: "my-0" },
                                          [
                                            _c("JobIndicator", {
                                              attrs: {
                                                status: _vm.getJobStatus(
                                                  page.type
                                                ),
                                                progress: _vm.getJobProgress(
                                                  page.type
                                                ),
                                                error: _vm.getJobError(
                                                  page.type
                                                ),
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleClickJob(
                                                    page.type
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  }
                                )
                              : _vm._e(),
                          ],
                          2
                        ),
                        _vm.currentCase
                          ? _c("MessageList", {
                              attrs: {
                                currentCase: _vm.currentCase,
                                jobInProgress: _vm.isJobInProgress,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
      _c(
        "keep-alive",
        [
          _c(
            "transition",
            [
              _c("router-view", {
                attrs: {
                  currentCase: _vm.currentCase,
                  errors: _vm.currentCaseErrors,
                  num_years: _vm.num_years,
                  "has-changed": _vm.hasChanged,
                  "drawer-state": _vm.navDrawer,
                },
                on: {
                  "toggle-drawer": function ($event) {
                    _vm.navDrawer = !_vm.navDrawer
                  },
                  change: _vm.caseChanged,
                  save: _vm.confirmSaveCase,
                  remove: _vm.removeCase,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600" },
          model: {
            value: _vm.reRunDialog,
            callback: function ($$v) {
              _vm.reRunDialog = $$v
            },
            expression: "reRunDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "text-h6 warning mb-4" },
                [_c("v-icon", [_vm._v("warning")]), _vm._v("Warning! ")],
                1
              ),
              _c("v-card-text", { staticClass: "text-body-1" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      "You will delete current outputs! Are you sure you want to run " +
                        _vm.mapTypeName(_vm.currentType) +
                        " again?"
                    ) +
                    " "
                ),
              ]),
              _c("v-card-text", { staticClass: "text-body-1" }, [
                _vm._v(
                  _vm._s(
                    _vm.currentType === 1 && _vm.aaAndPCComplete
                      ? "Production Cost Outputs will be invalid."
                      : ""
                  )
                ),
              ]),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", color: "red darken-1" },
                      on: {
                        click: function ($event) {
                          _vm.reRunDialog = false
                        },
                      },
                    },
                    [_vm._v(" Cancel ")]
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", text: "" },
                      on: {
                        click: function ($event) {
                          return _vm.reRunJob(_vm.currentType)
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            "Run " + "" + _vm.mapTypeName(_vm.currentType)
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "800" },
          model: {
            value: _vm.warningsDialog,
            callback: function ($$v) {
              _vm.warningsDialog = $$v
            },
            expression: "warningsDialog",
          },
        },
        [
          _c("WarningsDialog", {
            attrs: {
              type: _vm.currentType,
              warnings: _vm.currentWarnings,
              typeName: _vm.mapTypeName(_vm.currentType),
            },
            on: {
              close: function ($event) {
                _vm.warningsDialog = false
              },
              "re-run": _vm.reRunJob,
            },
          }),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600" },
          model: {
            value: _vm.invalidCaseDialog,
            callback: function ($$v) {
              _vm.invalidCaseDialog = $$v
            },
            expression: "invalidCaseDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-alert", { attrs: { type: "error", tile: "" } }, [
                _vm._v(" Error! "),
              ]),
              _c(
                "v-card-text",
                { staticClass: "pt-2" },
                [
                  _vm._v(
                    " This case has errors! Are you sure you want to save? "
                  ),
                  _c(
                    "v-list",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-list-item",
                        [
                          _c("v-list-item-title", [
                            _vm._v(
                              " Errors (total: " +
                                _vm._s(_vm.caseErrors.length) +
                                "): "
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._l(_vm.dialogErrors, function (error, i) {
                        return _c(
                          "v-list-item",
                          { key: i, staticClass: "error-item" },
                          [
                            _c("v-list-item-subtitle", [
                              _vm._v(" " + _vm._s(_vm.parseError(error)) + " "),
                            ]),
                          ],
                          1
                        )
                      }),
                      _vm.caseErrors.length > 5
                        ? _c(
                            "v-list-item",
                            [
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { top: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function (ref) {
                                          var on = ref.on
                                          return [
                                            _c(
                                              "p",
                                              _vm._g(
                                                {
                                                  staticClass:
                                                    "text-clickable text-caption",
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.showAllErrors =
                                                        !_vm.showAllErrors
                                                    },
                                                  },
                                                },
                                                on
                                              ),
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.showAllErrors
                                                        ? "Collapse"
                                                        : "..."
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3083733816
                                  ),
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.showAllErrors
                                          ? "Collapse items"
                                          : "Show all"
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "green darken-1", text: "" },
                      on: {
                        click: function ($event) {
                          _vm.invalidCaseDialog = false
                        },
                      },
                    },
                    [_vm._v(" Nevermind ")]
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "green darken-1",
                        text: "",
                        loading: _vm.caseSavePending,
                      },
                      on: { click: _vm.confirmSaveCase },
                    },
                    [_vm._v(" Save Anyways ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "400" },
          model: {
            value: _vm.confirmSaveDialog,
            callback: function ($$v) {
              _vm.confirmSaveDialog = $$v
            },
            expression: "confirmSaveDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "text-h5 warning" },
                [_c("v-icon", [_vm._v("warning")]), _vm._v("Warning! ")],
                1
              ),
              _c(
                "v-card-text",
                [
                  _vm._v(
                    " This case has outputs that will be deleted if you save this case. "
                  ),
                  _c("br"),
                  _vm._v("Would you like to save your changes as a new case? "),
                  _c("v-text-field", {
                    attrs: {
                      label: "New Case",
                      type: "text",
                      "hide-details": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "append-outer",
                        fn: function () {
                          return [
                            _c(
                              "v-btn",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.saveCaseAs(_vm.newCaseName)
                                  },
                                },
                              },
                              [_vm._v("Save As")]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                    model: {
                      value: _vm.newCaseName,
                      callback: function ($$v) {
                        _vm.newCaseName = $$v
                      },
                      expression: "newCaseName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "green darken-1", text: "" },
                      on: {
                        click: function ($event) {
                          _vm.confirmSaveDialog = false
                        },
                      },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "green darken-1",
                        text: "",
                        loading: _vm.caseSavePending,
                      },
                      on: { click: _vm.saveCase },
                    },
                    [_vm._v(" Save Anyways ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }